import { Dispatch, SetStateAction } from 'react';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import { Header } from './styles';

interface ListHeaderInterface {
  doesListExists: boolean;
  hasError: boolean;
  filteredListLength: number;
  singularLabel: string;
  pluralLabel: string;
  setAddPostModalShow: Dispatch<SetStateAction<boolean>>,
}

export default function ListHeader({
  doesListExists,
  hasError,
  filteredListLength,
  singularLabel,
  pluralLabel,
  setAddPostModalShow,
}: ListHeaderInterface) {
  return (
    <OpacityAnimation delay={0.1}>
      <Header doesListExists={doesListExists} apiFetched={!hasError}>
        {(doesListExists) && (
          <div className="leftAlignment">
            <strong>
              {filteredListLength}
              {' '}
              {filteredListLength === 1 ? singularLabel : pluralLabel}
            </strong>
          </div>
        )}
        <div className="actionButtons">
          <button type="button" onClick={() => setAddPostModalShow(true)}>Nova publicação</button>
        </div>
      </Header>
    </OpacityAnimation>
  );
}
